import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";
import { PropsWithChildren } from "react";

interface StatCardProps extends PropsWithChildren {
  title: string;
  icon?: LucideIcon;
  size?: "large" | "small";
}

export function StatCard({ title, children, size = "large" }: StatCardProps) {
  return (
    <Card>
      <CardHeader className="p-0 px-6 pt-[18px] pb-2.5">
        <CardDescription>
          {title}
        </CardDescription>
      </CardHeader>
      <CardContent className="px-6 pb-5">
        <CardTitle>
          {size === "large" ? (
            <h1>{children}</h1>
          ) : (
            <h2>{children}</h2>
          )}
        </CardTitle>
      </CardContent>
    </Card>
  );
}
